"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.model = void 0;
var model = exports.model = {
  //默认头部
  headerdefault: {
    tabbackground: '#409EFF',
    tabfontcolor: '#000',
    aside: '#409EFF'
  },
  headerdedark: {
    tabbackground: '#409EFF',
    tabfontcolor: '#fff',
    aside: '#409EFF'
  },
  headerthreme: {
    tabbackground: "#409EFF",
    tabfontcolor: '#fff',
    aside: '#409EFF'
  },
  //默认主题颜色
  themebackground: {
    contentbackground: '#409EFF',
    contenthouverbackground: "#e6f7ff",
    tabfontcolor: '#e6f7ff',
    aside: '#409EFF'
  }
};